const translation = {
  tags: {
    social: '사회적인',
    finance: '금융',
    travel: '여행하다',
    search: '검색',
    entertainment: '오락',
    utilities: '유틸리티',
    productivity: '생산력',
    weather: '날씨',
    other: '다른',
    videos: '동영상',
    news: '소식',
    medical: '내과의',
    education: '교육',
    image: '이미지',
    design: '디자인',
    business: '사업',
    agent: '대리인',
  },
  allTags: '모든 태그',
  searchTags: '검색 태그',
}

export default translation
